import React from 'react';
import { Row, Col } from 'react-bootstrap';

interface FormCardProps {
  children: React.ReactNode;
  className?: string;
}

/** Обёртка формы в карточку (единый стиль для create/edit страниц). Ограниченная ширина по центру. */
export const FormCard: React.FC<FormCardProps> = ({ children, className = '' }) => (
  <Row className="mx-0 justify-content-center">
    <Col xs={12} className={`p-3 text-bg-light border rounded my-2 form-card-col ${className}`.trim()}>
      {children}
    </Col>
  </Row>
);

export default FormCard;
